import { render, staticRenderFns } from "./pageNrBox.vue?vue&type=template&id=8a09e042&"
import script from "./pageNrBox.vue?vue&type=script&lang=js&"
export * from "./pageNrBox.vue?vue&type=script&lang=js&"
import style0 from "./pageNrBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports